var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio-btn-single",attrs:{"for":_vm.randomSelectId}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('input',{attrs:{"id":_vm.randomSelectId,"type":"radio","name":_vm.name},domProps:{"checked":_vm.checked,"value":_vm.value},on:{"change":_vm.emitChange}}),_c('span',{staticClass:"checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }